<template>
  <v-dialog
    v-model="showModal"
    persistent
    fullscreen
  >
    <div class="content-section">
      <br>
      <v-btn
        fab
        color="#FFF"
        small
        rounded
        elevation="0"
        class="close-button"
        @click="showModal = false"
      >
        <v-icon color="#37474f">
          mdi mdi-close
        </v-icon>
      </v-btn>
      <div v-if="checkAppUserCheckInRecord">
        <div class="d-flex justify-center align-center">
          <div class="profile-image">
            <img
              v-if="getImageUrl !== ''"
              :src="getImageUrl"
              alt=""
              width="80px"
            >
            <img
              v-else
              src="../../../../../assets/img/user-profile.png"
              alt=""
              width="80px"
            >
          </div>
        </div>

        <h1 class="header-style d-flex justify-center align-center">
          {{ appUserCheckInRecord[0].app_user.first_name }}
          {{ appUserCheckInRecord[0].app_user.last_name }}
        </h1>
        <br>
        <v-card
          color="white"
          elevation="0"
          class="mb-3 mt-2 px-3 pt-3 pb-1"
        >
          <p class="title-text-style">
            <span class="mdi mdi-domain" /> Company:
            <font class="value-text-style">
              {{ appUserCheckInRecord[0].app_user.company.name }}
            </font>
          </p>
          <p class="title-text-style">
            <span class="mdi mdi-file-multiple-outline" /> Category:
            <font
              v-if="appUserCheckInRecord[0].app_user.worker_category !== null"
              class="value-text-style"
            >
              {{ appUserCheckInRecord[0].app_user.worker_category.name }}
            </font>
            <font v-else>
              N/A
            </font>
          </p>
          <p class="title-text-style">
            <span class="mdi mdi-account-hard-hat" /> High Risk Worker
            (HRW):
            <font :color="getColor(appUserCheckInRecord[0].app_user.high_risk_worker)">
              {{ appUserCheckInRecord[0].app_user.high_risk_worker | statusUpdate }}
            </font>
          </p>
        </v-card>
        <span class="subheader-style">Check-in Details</span>
        <v-card
          v-for="activity in appUserCheckInRecord"
          :key="activity.id"
          color="#FFF"
          elevation="0"
          class="mb-3 mt-2"
        >
          <v-card-text>
            <p class="title-text-style">
              Project:
              <font class="value-text-style">
                {{ activity.project.name }}
              </font>
            </p>

            <!-- <legend>
              <b><font color="green">Check-in</font></b>
            </legend> -->
            <p class="title-text-style">
              Check-in Gate:
              <font
                v-if="activity.checkin_gate !== null"
                class="value-text-style"
              >
                {{ activity.checkin_gate.name }}
              </font>
              <font
                v-if="activity.checkin_kiosk !== null"
                class="value-text-style"
              >
                {{ activity.checkin_kiosk.location_name }} [Kiosk]
              </font>
              <font
                v-if="
                  activity.checkin_kiosk === null &&
                    activity.checkin_gate === null
                "
                class="value-text-style"
              >
                N/A
              </font>
              <font
                v-if="activity.checkin_method_type === 'cost-shift'"
                class="value-text-style"
              >
                [Cost-Shift]
              </font>
            </p>
            <p class="title-text-style">
              Check-in At:
              <font
                v-if="activity.checkin_time !== null"
                class="value-text-style"
              >
                {{ activity.checkin_time | convertToLocal }}
              </font>
              <font v-else>
                N/A
              </font>
            </p>
            <p class="title-text-style">
              Check-in Type:
              <font class="value-text-style">
                {{ activity.type }}
              </font>
            </p>
            <p
              v-if="activity.contract_details !== null"
              class="title-text-style"
            >
              Check-in Type:
              <font class="value-text-style">
                {{ activity.contract_details.contract.name }}
              </font>
            </p>
            <p
              v-if="activity.contract_details !== null"
              class="title-text-style"
            >
              Check-in Items:
              <font class="value-text-style">
                {{ activity.contract_details.contract.budget_items.length }}
                Nos
                <div
                  v-for="(item, index) in activity.contract_details.contract
                    .budget_items"
                  :key="index"
                  class="mt-3"
                >
                  <font>{{ index + 1 }}. {{ item.name }}</font>
                </div>
              </font>
            </p>
            <p
              v-if="
                activity.work_details !== null &&
                  activity.work_details.type === 'project-work'
              "
              class="title-text-style"
            >
              Budget Name:
              <font class="value-text-style">
                {{ activity.work_details.budget.name }}
              </font>
            </p>
            <p
              v-if="
                activity.work_details !== null &&
                  activity.work_details.type === 'project-work'
              "
              class="title-text-style"
            >
              High Risk Work (HRW):
              <font :color="getColor(activity.app_user.high_risk_worker)">
                {{
                  activity.work_details.budget.high_risk_work | statusUpdate
                }}
              </font>
            </p>
            <p
              v-if="
                activity.work_details !== null &&
                  activity.work_details.type === 'project-work'
              "
              class="title-text-style"
            >
              Status:
              <font
                :color="getStatusColor(activity.work_details.budget.status)"
              >
                {{ activity.work_details.budget.status }}
              </font>
            </p>
            <p
              class="title-text-style"
            >
              Check-out At:
              <font
                v-if="activity.checkout_time !== null"
                class="value-text-style"
              >
                {{ activity.checkout_time | convertToLocal }}
              </font>
              <font
                v-else
                class="value-text-style"
              >
                N/A
              </font>
            </p>
            <p class="title-text-style">
              Check-out Gate:
              <font
                v-if="activity.checkout_gate !== null"
                class="value-text-style"
              >
                {{ activity.checkout_gate.name }}
              </font>
              <font
                v-if="activity.checkout_kiosk !== null"
                class="value-text-style"
              >
                {{ activity.checkout_kiosk.location_name }} [Kiosk]
              </font>
              <font
                v-if="
                  activity.checkout_kiosk === null &&
                    activity.checkout_gate === null
                "
                class="value-text-style"
              >
                N/A
              </font>
              <font
                v-if="activity.manual_checkout === true"
                class="value-text-style"
              >
                [Manual Checkout]
              </font>
              <font
                v-if="activity.checkout_method_type === 'cost-shift'"
                class="value-text-style"
              >
                [Cost-Shift]
              </font>
            </p>
            <p class="title-text-style">
              Total Work Hours:
              <font
                v-if="activity.total_hours !== null"
                class="value-text-style"
              >
                {{ activity.total_hours }} Hrs
              </font>
              <font
                v-if="activity.total_hours === null"
                class="value-text-style active-color"
              >
                Onsite
              </font>
            </p>
          </v-card-text>
        </v-card>
      </div>
    </div>
    <centre-spinner :loading="loading" />
  </v-dialog>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import moment from 'moment';
export default {
  name: 'AppUserAttendenceRecords',
  components: {
    'centre-spinner': spinner,
  },
  filters: {
    arrangePretty (val) {
      if (Array.isArray(val)) {
        return val
          .map((type) => (type === 'staff' ? 'Site Manager' : type))
          .join(', ');
      }
      return val;
    },
    statusUpdate (val) {
      if (val === true) {
        return 'Yes*';
      }
      return 'No';
    },
    convertToLocal (stringDatetime) {
      return moment(stringDatetime).local().format('Do MMMM YYYY A');
    },
  },
  props: {
    attendenceId: {
      type: String,
      required: true,
    },
    checkinDate: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      showModal: true,
      loading: false,
    };
  },
  computed: {
    appUserCheckInRecord () {
      return this.$store.getters['swiftuser/getAppUserActivities'];
    },
    checkAppUserCheckInRecord () {
      if (Object.keys(this.appUserCheckInRecord).length !== 0) {
        return true;
      }
      return false;
    },
    getImageUrl () {
      if (this.checkAppUserCheckInRecord) {
        const baseUrl = process.env.VUE_APP_STORAGE_API_URL;
        const image = this.appUserCheckInRecord[0].app_user.profile_image;
        if (image && image.file_path) {
          return `${baseUrl}/${image.file_path}`;
        }
        return '';
      }
      return '';
    },
  },
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  async mounted () {
    this.loading = true;
    await this.clearActiveCheckInDetails();
    await this.getAppUserCheckInRecord();
    this.loading = false;
  },
  methods: {
    async getAppUserCheckInRecord () {
      this.loading = true;
      const { start, end } = this.getUTCDateRangeFromLocalDate(
        this.checkinDate ? this.checkinDate : moment().format('YYYY-MM-DD'),
      );
      await this.$store.dispatch('swiftuser/fetchAppUserActivities', {
        attendenceId: this.attendenceId,
        params: {
          params: {
            limit: 10,
            startPage: 0,
            from: start,
            to: end,
          },
        },
      });
      this.loading = false;
    },
    getUTCDateRangeFromLocalDate (localDate) {
      const start = moment(localDate + ' 00:00:00', 'YYYY-MM-DD hh:mm:ss')
        .utc()
        .format();
      const end = moment(localDate + ' 23:59:59', 'YYYY-MM-DD hh:mm:ss')
        .utc()
        .format();
      return { start, end };
    },
    clearActiveCheckInDetails () {
      this.loading = true;
      this.$store.dispatch('swiftuser/clearActiveCheckInDeatils');
      this.loading = false;
    },
    getColor (val) {
      if (val === false) {
        return '#2E7D32';
      }
      return '#C62828';
    },
    getStatusColor (val) {
      if (val === 'active') {
        return '#2E7D32';
      } else if (val === 'pending') {
        return '#C62828';
      } else if (val === 'completed') {
        return '#FF3700';
      } else {
        return '#EF6C00';
      }
    },
  },
};
</script>
<style scoped>
.check-style {
  font-weight: 500;
  font-size: 18px;
}

.active-color {
  color: #2e7d32;
}

.profile-image {
  height: 80px;
  width: 80px;
  border-radius: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
}
fieldset {
  border-radius: 10px !important;
  padding: 0.5rem;
}
.close-button {
  z-index: 999;
}

legend {
  font-weight: bold;
  padding: 0 10px;
}
</style>
